import { validateFile } from "../_generic/validate";
import Workbook from "../_generic/Workbook";


async function extractSameDayExcelFile(file) {
    const validation = validateFile(file);
    if(!validation.ok) return validation;

    const workbook = await Workbook.fromFile(file);
    const data = extractSameDayData(workbook.sheets[0]);

    return { ok: true, data };
}


/**
 * 
 * @param {Sheet} sheet 
 */
function extractSameDayData(sheet) {
    const columns = {
        name: "B", 
        category: "C",
        domestic_local_male: "D",
        domestic_local_female: "E",
        domestic_local_total: "F",
        domestic_external_male: "G",
        domestic_external_female: "H",
        domestic_external_total: "I",
        foreign_male: "J",
        foreign_female: "K",
        foreign_total: "L"
    };

    const startRow = 12;
    const anchorColumn = "B";

    const { data } = sheet.readRows(columns, { startRow, anchorColumn });

    return data.map(row => {
        let { name, category, 
            domestic_local_male, domestic_local_female, domestic_local_total,
            domestic_external_male, domestic_external_female, domestic_external_total,
            foreign_male, foreign_female, foreign_total } = row;

        let domestic_local_ngd = 0;
        let domestic_external_ngd = 0;
        let foreign_ngd = 0;
        
        if(!domestic_local_male && !domestic_local_female) 
            domestic_local_ngd = domestic_local_total;
        if(!domestic_external_male && !domestic_external_female) 
            domestic_external_ngd = domestic_external_total;
        if(!foreign_male && !foreign_female) 
            foreign_ngd = foreign_total;
        

        return { 
            name, category, counts: {
            domestic: {
                local: { 
                    male: domestic_local_male || 0, 
                    female: domestic_local_female || 0, 
                    ngd: domestic_local_ngd || 0 
                },
                external: { 
                    male: domestic_external_male || 0, 
                    female: domestic_external_female || 0, 
                    ngd: domestic_external_ngd || 0 
                },
            },
            foreign: { 
                male: foreign_male || 0, 
                female: foreign_female || 0, 
                ngd: foreign_ngd || 0 
            }
        }};

    });
}

export { extractSameDayExcelFile };
